<template>
    <div>
      <div ref="editor" class="quill-editor"></div>
    </div>
  </template>
  
  <script>
  import Quill from 'quill';
  import 'quill/dist/quill.snow.css';
  
  export default {
    name: 'QuillEditor',
    props: {
      modelValue: {
        type: String,
        required: true
      }
    },
    mounted() {
      this.editor = new Quill(this.$refs.editor, {
        theme: 'snow',
        modules: {
          toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link', 'image'],
          ]
        }
      });
      this.editor.root.innerHTML = this.modelValue;
  
      this.editor.on('text-change', () => {
        this.$emit('update:modelValue', this.editor.root.innerHTML);
      });
    },
    watch: {
      modelValue(newValue) {
        if (newValue !== this.editor.root.innerHTML) {
          this.editor.root.innerHTML = newValue;
        }
      }
    }
  }
  </script>
  
  <style scoped>
  @import 'quill/dist/quill.snow.css';
  .quill-editor {
  height: 130px; /* Altezza approssimativa per 5 righe di testo */
  max-height: 130px; /* Imposta un'altezza massima */
  overflow-y: auto; /* Aggiungi lo scorrimento verticale se necessario */
}
  </style>
  